import i18next from "i18next";
import {
  RemoteChildDataSource,
  RemoteChildDataSourceOptions
} from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { RemoteListChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteListChildDataSource";
import { RemoteOneChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteOneChildDataSource";
import { action, observable } from "mobx";
import { api } from "../../core/mainStore";

export class TreeDataSource<T, ID> extends RemoteChildDataSource<T, ID> {
  @observable public listDataSource: TreeListDataSource<T, ID>;
  @observable public oneDataSource: TreeOneDataSource<T, ID>;

  public constructor(options: RemoteChildDataSourceOptions) {
    super(options);
    this.listDataSource = new TreeListDataSource<T, ID>({ ...options });
    this.oneDataSource = new TreeOneDataSource<T, ID>({ ...options });
  }
}

export class TreeOneDataSource<T, ID> extends RemoteOneChildDataSource<T, ID> {
  @action
  public async activateTree(): Promise<void> {
    await this.executeRemote("tree.activate", async () => {
      // @ts-ignore
      await api.postMethod(`${this.url}/${this.one.id}/activate`);
      this.commons.newSuccess(i18next.t("hns:tree:activated"));
    });
  }

  @action
  public async deactivateTree(): Promise<void> {
    await this.executeRemote("tree.deactivate", async () => {
      // @ts-ignore
      await api.postMethod(`${this.url}/${this.one.id}/deactivate`);
      this.commons.newSuccess(i18next.t("hns:tree:deactivated"));
    });
  }
}

export class TreeListDataSource<T, ID> extends RemoteListChildDataSource<
  T,
  ID
> {}
